import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";

export default function DateModified() {
  const { language } = useLanguage();
  const t = translations[language];
  const lastModified = import.meta.env.VITE_LAST_MODIFIED;

  return (
    <div className="max-w-7xl mx-auto px-4 py-6 text-sm text-gray-700 border-t border-gray-300">
      <span>{t.dateModifiedLabel}</span>{" "}
      {lastModified || t.error}
      {console.log("Last Modified: ", lastModified)}
    </div>
  );
}